import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async saveWhatsAppApp({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/apps",
        method: "POST",
        data: data,
      });

      let app = response.data.data;

      commit(MutationsType.SET_WHATSAPP_APP, app);
      commit(MutationsType.ADD_WHATSAPP_APP, app);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getWhatsAppAppConfig({ commit, state }, { id }) {
    try {
      let app = (state.apps || []).find((p) => p.id === id);
      if (!app) {
        let response = await requestAxios({
          url: `/awy/api/v1/channels/whatsapp/apps/${id}`,
          method: "GET",
        });
        app = response.data.data;
      }
      commit(MutationsType.SET_WHATSAPP_APP, app);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllWhatsAppApps({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/apps",
        method: "GET",
      });

      commit(MutationsType.SET_WHATSAPP_APPS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateWhatsAppApp({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/channels/whatsapp/apps/${id}`,
        method: "PATCH",
        data: data,
      });

      let app = response.data.data;

      commit(MutationsType.UPDATE_WHATSAPP_APP, app);
    } catch (error) {
      throw error.response.data;
    }
  },
  async subscribeWhatsAppApp({ commit, state }, { wabaId, code, phoneNumberId }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v2/channels/whatsapp",
        method: "POST",
        data: { phone_number_id: phoneNumberId, waba_id: wabaId, code: code },
      });

      let app = response.data.data;

      if (!state.apps) commit(MutationsType.SET_WHATSAPP_APPS, []);

      commit(MutationsType.ADD_WHATSAPP_APP, app);
    } catch (error) {
      throw error.response.data;
    }
  },
  async unsubscribeWhatsAppApp({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v2/channels/whatsapp/${id}`,
        method: "DELETE",
      });

      commit(MutationsType.DELETE_WHATSAPP_APP, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteWhatsAppApp({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/channels/whatsapp/apps/${id}`,
        method: "DELETE",
      });

      commit(MutationsType.DELETE_WHATSAPP_APP, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateWhatsAppAppPhoneNumber({ commit }, { phoneNumberId }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v2/channels/whatsapp/phone-numbers/${phoneNumberId}`,
        method: "PATCH",
      });

      commit(MutationsType.UPDATE_WHATSAPP_PHONE_NUMBER, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async registerWhatsAppAppPhoneNumber({}, { phoneNumberId }) {
    try {
      await requestAxios({
        url: `/awy/api/v2/channels/whatsapp/phone-numbers/${phoneNumberId}/register`,
        method: "POST",
      });

      // commit(MutationsType.UPDATE_WHATSAPP_PHONE_NUMBER, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async requestWhatsAppAppPhoneNumberCode({}, { phoneNumberId, codeMethod }) {
    try {
      await requestAxios({
        url: `/awy/api/v2/channels/whatsapp/phone-numbers/${phoneNumberId}/request-code`,
        method: "POST",
        data: { code_method: codeMethod },
      });

      // commit(MutationsType.UPDATE_WHATSAPP_PHONE_NUMBER, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async verifyWhatsAppAppPhoneNumberCode({}, { phoneNumberId, code }) {
    try {
      await requestAxios({
        url: `/awy/api/v2/channels/whatsapp/phone-numbers/${phoneNumberId}/verify-code`,
        method: "POST",
        data: { code },
      });

      // commit(MutationsType.UPDATE_WHATSAPP_PHONE_NUMBER, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveWhatsAppAppPhoneNumber({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/phone-numbers",
        method: "POST",
        data: data,
      });

      commit(MutationsType.ADD_WHATSAPP_PHONE_NUMBER, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async getWhatsAppAppRemotePhoneNumbers({}, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/remote-phone-numbers",
        method: "GET",
        params: data,
      });

      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllWhatsAppPhoneNumbers({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/phone-numbers",
        method: "GET",
      });

      commit(MutationsType.SET_WHATSAPP_PHONE_NUMBERS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteWhatsAppPhoneNumber({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/channels/whatsapp/phone-numbers/${id}`,
        method: "DELETE",
      });

      commit(MutationsType.DELETE_WHATSAPP_PHONE_NUMBER, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async getWhatsAppDataset({}, { appId }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v2/channels/whatsapp/apps/${appId}/dataset`,
        method: "GET",
      });

      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveWhatsAppDataset({ commit }, { appId }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v2/channels/whatsapp/apps/${appId}/dataset`,
        method: "POST",
      });

      commit(MutationsType.UPDATE_WHATSAPP_APP, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveWhatsAppMessageTemplate({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/message-templates",
        method: "POST",
        data: data,
      });

      commit(MutationsType.ADD_WHATSAPP_MESSAGE_TEMPLATE, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateWhatsAppMessageTemplate({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/channels/whatsapp/message-templates/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_WHATSAPP_MESSAGE_TEMPLATE, response.data.data);
    } catch (error) {
      console.error("updateWhatsAppMessageTemplate: ", error);
      throw error.response.data;
    }
  },
  async getWhatsAppMessageTemplateById({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/channels/whatsapp/message-templates/${id}`,
        method: "GET",
      });

      commit(MutationsType.SET_WHATSAPP_MESSAGE_TEMPLATE, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllWhatsAppMessageTemplates({ commit, state, dispatch }) {
    try {
      if (!state.apps?.length) {
        await dispatch("getAllWhatsAppApps");
      }

      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/message-templates",
        method: "GET",
      });

      commit(MutationsType.SET_WHATSAPP_MESSAGE_TEMPLATES, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteWhatsAppMessageTemplate({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/channels/whatsapp/message-templates/${id}`,
        method: "DELETE",
      });

      commit(MutationsType.DELETE_WHATSAPP_MESSAGE_TEMPLATE, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  async syncWhatsAppSyncRemoteTemplates({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/sync-remote-message-templates",
        method: "POST",
      });

      commit(MutationsType.SET_WHATSAPP_MESSAGE_TEMPLATES, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveWhatsAppQuickReply({ commit, state }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/quick-replies",
        method: "POST",
        data: data,
      });

      if (!state.quickReplies) commit(MutationsType.SET_WHATSAPP_QUICK_REPLIES, []);

      commit(MutationsType.ADD_WHATSAPP_QUICK_REPLY, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateWhatsAppQuickReply({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/channels/whatsapp/quick-replies/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_WHATSAPP_QUICK_REPLY, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getWhatsAppQuickReplyById({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/channels/whatsapp/quick-replies/${id}`,
        method: "GET",
      });

      commit(MutationsType.SET_WHATSAPP_QUICK_REPLY, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllWhatsAppQuickReplies({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/whatsapp/quick-replies",
        method: "GET",
      });

      commit(MutationsType.SET_WHATSAPP_QUICK_REPLIES, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteWhatsAppQuickReply({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/channels/whatsapp/quick-replies/${id}`,
        method: "DELETE",
      });

      commit(MutationsType.DELETE_WHATSAPP_QUICK_REPLY, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetWhatsAppQuickReply({ commit }) {
    commit(MutationsType.SET_WHATSAPP_QUICK_REPLY, null);
  },
  async enableWhatsAppAssistant({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/assistant",
        method: "POST",
      });

      const data = response.data.data;
      if (data.menu) commit(MutationsType.SET_WHATSAPP_ASSISTANT_NEW, data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getWhatsAppAssistantConfig({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/automations/new_ticket/menu",
        method: "GET",
      });

      commit(MutationsType.SET_WHATSAPP_ASSISTANT, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getWAAssistantConfig({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/channels/assistant",
        method: "GET",
      });

      const data = response.data.data;
      if (data.menu) commit(MutationsType.SET_WHATSAPP_ASSISTANT_NEW, data);
    } catch (error) {
      console.error(error);
      throw error.response.data;
    }
  },
  resetWhatsAppMessageTemplate({ commit }) {
    commit(MutationsType.SET_WHATSAPP_MESSAGE_TEMPLATE, null);
  },
  async setTeamSchema({ commit }, { data }) {
    commit(MutationsType.SET_TEAM_SCHEMA, { data });
  },
  async getWWebSession() {
    try {
      let response = await requestAxios({
        url: "/awy/api/v2/channels/wweb",
        method: "GET",
      });

      return response.data.data;
    } catch (error) {
      return error.response.data;
    }
  },
  async saveWWebSession() {
    try {
      let response = await requestAxios({
        url: "/awy/api/v2/channels/wweb",
        method: "POST",
      });

      return response.data.data;
    } catch (error) {
      return error.response.data;
    }
  },
  async updateWWebSession({ commit, rootState }) {
    try {
      const sessionId = rootState.Agent.agent.uid;
      let response = await requestAxios({
        url: `/awy/api/v2/channels/wweb/${sessionId}`,
        method: "PATCH",
      });

      let app = response.data.data;

      commit(MutationsType.UPDATE_WHATSAPP_APP, app);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteWWebSession({ commit, rootState }) {
    try {
      const sessionId = rootState.Agent.agent.uid;
      let response = await requestAxios({
        url: `/awy/api/v2/channels/wweb/${sessionId}`,
        method: "DELETE",
      });

      commit(MutationsType.DELETE_WHATSAPP_APP, { id: response.data.data.id });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleChannelAssistant({ commit }) {
    commit(MutationsType.SET_WHATSAPP_APP, null);
    commit(MutationsType.SET_WHATSAPP_APPS, null);
    commit(MutationsType.SET_WHATSAPP_MESSAGE_TEMPLATE, null);
    commit(MutationsType.SET_WHATSAPP_MESSAGE_TEMPLATES, null);
  },
};
